import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const getCurrentWeekOfMonth = () => {
  const now = new Date();
  const firstDayOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);

  const firstDayOfWeek = (firstDayOfMonth.getDay() + 6) % 7;

  const currentDay = now.getDate();

  const week = Math.ceil((currentDay + firstDayOfWeek) / 7);
  return week;
};

interface InitialState {
  year: number;
  month: number;
  week: number;
}

const initialState: InitialState = {
  year: new Date().getFullYear(),
  month: new Date().getMonth(),
  week: getCurrentWeekOfMonth(),
};

const controlMonthYearSelectedSlice = createSlice({
  name: "controlMonthYearSelected",
  initialState,
  reducers: {
    setMonthYearSelected: (
      state,
      action: PayloadAction<{ year: number; month: number; week?: number }>
    ) => {
      state.year = action.payload.year;
      state.month = action.payload.month;
      state.week = action.payload.week ?? getCurrentWeekOfMonth();
    },
  },
});

export const { setMonthYearSelected } = controlMonthYearSelectedSlice.actions;

export default controlMonthYearSelectedSlice.reducer;
